import React from "react";

import { useStoreSearchContext } from "../../../storeSearch.context";
import { SwitchTabComponent } from "./switchTab.component";

type SwitchTabProps = {};

export const SwitchTab = ({}: SwitchTabProps) => {
    const { tab, setTab } = useStoreSearchContext();

    const openList = () => setTab("list");
    const openMap = () => setTab("map");

    return (
        <SwitchTabComponent tab={tab} openList={openList} openMap={openMap} />
    );
};
